import { useTranslations } from '@vocab/react';
import { Actions, ButtonLink } from 'braid-design-system';
import type React from 'react';

import { createCAJALink } from 'src/App/components/JobActions/links';
import { useConfig } from 'src/hooks/useConfig';

import translations from './.vocab';

export const CreateJobButton: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslations(translations);
  const { urlResolver } = useConfig();

  const cajaLink = urlResolver({ path: createCAJALink() });

  return (
    <Actions>
      <ButtonLink href={cajaLink} tone="brandAccent">
        {t('Create a job ad')}
      </ButtonLink>
    </Actions>
  );
};
